import { MERKL_BASE } from '@/config/consts'
import { useQuery } from '@tanstack/react-query'
import type { Address } from 'viem'

const PARALLEL_INCENTIVIZED_COLLATERAL =
  '0xAc207FFa0bfcE194Db18D1820902D48a2d948968'.toLowerCase() as Lowercase<Address>
const PARALLEL_INCENTIVIZED_LIABILITY = '0xF9BB65e113418292d1a3555515fBd64637a0BE18'.toLowerCase() as Lowercase<Address>

export const PARALLEL_MERKL_CLAIM_URL =
  'https://app-merkl.angle.money/opportunities/hyperevm/EULER/0x13ff9cf58508e5c394caf03bbf40a4af334a11f3'

export interface ParallelBorrowIncentives {
  apr: number
  description: string
  claimUrl: string
}

export function isParallelIncentivizedBorrowPair(collateral?: Address, liability?: Address): boolean {
  if (!collateral || !liability) return false

  return (
    collateral.toLowerCase() === PARALLEL_INCENTIVIZED_COLLATERAL &&
    liability.toLowerCase() === PARALLEL_INCENTIVIZED_LIABILITY
  )
}

export function useParallelBorrowIncentives() {
  const { data: parallelBorrowIncentives } = useQuery<ParallelBorrowIncentives | null>({
    queryKey: ['parallelBorrowIncentives'],
    queryFn: async () => {
      const response = await fetch(`${MERKL_BASE}/creators/campaigns/10698515856545977411`)

      if (!response.ok) {
        return null
      }

      const data = await response.json()
      const apr = Number(data.aprRecords?.[0]?.apr ?? 0)

      return apr > 0
        ? {
            apr,
            description: 'Borrowing this asset is being incentivized by Parallel. Claim your rewards now.',
            claimUrl: PARALLEL_MERKL_CLAIM_URL,
          }
        : null
    },
    staleTime: 5 * 60 * 1000,
  })

  return parallelBorrowIncentives
}
